// 1、引入vuex
import Vue from 'vue'
import Vuex from 'vuex'
// 导入user模块
import user from './user'
Vue.use(Vuex)

//2、定义公共的数据及方法
const store = new Vuex.Store({
	// 全局数据变量
	// 相当于data
	state: {
		login: false,
		nickname:'',
		credentialsPrice:0,
		credentialName:''
	},
	// 相当于computed
	getters:{
		
	},
	// 注册模块
	modules:{
		user,
	},
	// 同步，相当于methods
	mutations: {
		credentialsPrice(state,credentialsPrice){
			state.credentialsPrice=credentialsPrice
		},
		credentialName(state,credentialName){
			state.credentialName=credentialName
		}
	},
	// 异步
	actions: {

	}
})
///3、导出
export default store
